import React from "react";
import styled from "styled-components";
import { StyledTabs } from "../../styles/shared-components";
import { colors, spacing } from "../../styles/theme";
import { ProductsTab } from "../organisms/menu-products-tab/ProductsTab";
import { AdditionsTab } from "../organisms/menu-additions-tab/AdditionsTab";
import { useAdditionsTour } from "../../contexts/additions-tour-context/useAdditionsTour";
import { useResponsive } from "../../hooks/useResponsive";

const MenuWrapper = styled.div`
  padding: ${spacing.xxl} 40px;
  background: ${colors.white};
  min-height: calc(100vh - 64px);

  @media (max-width: 768px) {
    padding: ${spacing.md};
  }
`;

const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: ${colors.textPrimary};
  margin: 0 0 ${spacing.xl} 0;
`;

const TabContentFullWidth = styled.div`
  width: 100%;
`;

export const MenuNew: React.FC = () => {
  const { additionsTabRef, isTourOpen, activeTour, tourStep, advanceStep } = useAdditionsTour();
  const { isMobile } = useResponsive();

  // Desktop: ADDITIONS_TAB = step 3, Mobile: ADDITIONS_TAB = step 4 (only in create-additions)
  const additionsTabStep = isMobile ? 4 : 3;

  const handleAdditionsTabClick = () => {
    if (isTourOpen && activeTour === "create-additions" && tourStep === additionsTabStep) {
      setTimeout(() => advanceStep(additionsTabStep), 300);
    }
  };

  const items = [
    {
      key: "products",
      label: "Produkty",
      children: (
        <TabContentFullWidth>
          <ProductsTab />
        </TabContentFullWidth>
      ),
    },
    {
      key: "additions",
      label: (
        <span ref={additionsTabRef as React.RefObject<HTMLSpanElement>}>
          Dodatki
        </span>
      ),
      children: (
        <TabContentFullWidth>
          <AdditionsTab />
        </TabContentFullWidth>
      ),
    },
  ];

  return (
    <MenuWrapper>
      <PageTitle>Menu</PageTitle>
      <StyledTabs
        defaultActiveKey="products"
        items={items}
        size="large"
        onTabClick={(key) => {
          if (key === "additions") {
            handleAdditionsTabClick();
          }
        }}
      />
    </MenuWrapper>
  );
};

export default MenuNew;
